var _path, _path2, _rect, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAttendeesOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 28,
    viewBox: "0 0 41 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.5455L13.9 2V11.4545H23L11.1 26V16.5455H2Z",
    fill: "url(#paint0_linear_161_15)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.5455L13.9 2V11.4545H23L11.1 26V16.5455H2Z",
    stroke: "#14B4C2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 20,
    width: 20,
    height: 8,
    rx: 4,
    fill: "#14B4C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4424 21.7988V25.2207H27.4375V26H24.5459V21.7988H25.4424ZM28.2432 21.7988H29.1396V26H28.2432V21.7988ZM31.3398 26L29.8252 21.7988H30.7363L31.8262 24.8545L32.9219 21.7988H33.833L32.3184 26H31.3398ZM37.4512 21.7988V22.5811H35.4561V23.5303H37.0967V24.2686H35.4561V25.2207H37.4512V26H34.5596V21.7988H37.4512Z",
    fill: "#05001E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_161_15",
    x1: 12.5,
    y1: 2,
    x2: 12.5,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14B4C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14B4C2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttendeesOnline);
export default __webpack_public_path__ + "static/media/icon-attendees-online.01b7e412bef5b8031cf2a73402a3fb8d.svg";
export { ForwardRef as ReactComponent };